import { useState, useEffect, RefObject } from 'react';

export const useWindowResize = (menuRef: RefObject<Element>, lcmCardRef: RefObject<Element>) => {
  const [width, setWidth] = useState(0);
  const [screenWidth, setScreenWidth] = useState(0);

  useEffect(() => {
    if (!menuRef.current) return;
    const observer = new ResizeObserver(entries => {
      const menuElement = entries[0].target as HTMLElement;
      let menuWidth = 170;
      if (!menuElement.classList.contains('closed')) {
        menuWidth = entries[0].contentBoxSize[0].inlineSize + 130;
      }
      setWidth(document.body.clientWidth - menuWidth);
    });

    observer.observe(menuRef.current);
    return () => observer.disconnect();
  }, [menuRef]);

  useEffect(() => {
    if (!lcmCardRef.current) return;
    const observer = new ResizeObserver(() => {
      setScreenWidth(document.body.offsetWidth);
    });

    observer.observe(lcmCardRef.current);
    return () => observer.disconnect();
  }, [lcmCardRef]);

  return { width, screenWidth };
};